module.exports = __webpack_public_path__ + "img/historyImg1.d57d5286.jpg";